import { useMemo } from 'react';
import {
  filterDiscountRates,
  filterFreeTicketsRates,
  getFreeTickets,
  getTicketPriceConsideringFreeTickets,
  priceFormat,
} from '../helpers/calculateDiscountAndCredits';
import { getSingleOrdersDiscountData } from '../helpers/discounts';

const useBundlePricing = ({
  ticketsCount,
  prize,
  discountRates,
  discount,
  generalSettings,
  isLandingTicket,
  landingTicket,
  isDoubleTickets,
}) => {
  return useMemo(() => {
    if (!prize || !generalSettings || !ticketsCount) {
      return {
        oldPrice: 0,
        newPrice: 0,
        finalPrice: 0,
        totalTickets: ticketsCount || 0,
        ticketUnitPrice: 0,
        pricePerTicket: '0 £',
        savingPercent: 0,
        formattedTotal: priceFormat(0),
        formattedFinal: priceFormat(0),
        hasTemporarySingleDiscount: false,
        temporaryDiscountAmount: 0,
        temporaryDiscountLabel: null,
        hideOldPrice: false,
      };
    }

    // 1. Basic price
    const actualDiscount = filterDiscountRates(discountRates || [], ticketsCount);

    let oldPrice;
    if (actualDiscount) {
      oldPrice = ticketsCount * actualDiscount.newPrice;
    } else {
      oldPrice = ticketsCount * prize.ticketPrice;
    }

    // 2. After discount
    let newPrice = oldPrice;

    if (discount && discount.status === true && oldPrice !== 10) {
      newPrice = oldPrice * (1 - discount.value);
    }

    // 3. temporary discount
    const { temporaryDiscountAmount, temporaryDiscountLabel, hideFullPrice } = getSingleOrdersDiscountData(
      generalSettings?.singleOrdersDiscount,
      ticketsCount,
    );
    const hideOldPrice = !!hideFullPrice;

    const finalPrice = newPrice - temporaryDiscountAmount;
    const hasTemporarySingleDiscount = temporaryDiscountAmount > 0 ? true : false;

    // 4. free tickets
    let freeTickets = 0;

    const freeTicketsRates = getFreeTickets(prize, generalSettings);
    const actualFree = filterFreeTicketsRates(freeTicketsRates, ticketsCount);

    if (actualFree && actualFree.extra) {
      freeTickets = actualFree.extra;
    }

    const totalTickets = ticketsCount + freeTickets;

    // 5. price per ticket
  
    let ticketUnitPrice = Math.round((finalPrice * 100) / totalTickets - 0.2);

    // 6. pricePerTicket
    let pricePerTicket;

    if (isLandingTicket) {
      pricePerTicket = landingTicket.pricePerTicket;
    } else {
      const calculated = getTicketPriceConsideringFreeTickets(
        prize,
        generalSettings,
        ticketsCount,
        discountRates || [],
        isDoubleTickets,
      );

      if (calculated) {
        pricePerTicket = calculated;
      } else {
        pricePerTicket = prize.ticketPrice + ' £';
      }
    }

    // 7. % percents ec
    let savingPercent = 0;

    if (oldPrice > 0) {
      savingPercent = Math.round(((oldPrice - finalPrice) / oldPrice) * 100);
    }

    return {
      oldPrice,
      newPrice,
      finalPrice,
      totalTickets,
      ticketUnitPrice,
      pricePerTicket,
      savingPercent,
      formattedTotal: priceFormat(Math.ceil(newPrice)),
      formattedFinal: priceFormat(Math.ceil(finalPrice)),
      hasTemporarySingleDiscount,
      temporaryDiscountAmount,
      temporaryDiscountLabel,
      hideOldPrice,
    };
  }, [
    ticketsCount,
    prize,
    discountRates,
    discount,
    generalSettings,
    isLandingTicket,
    landingTicket,
    isDoubleTickets,
  ]);
};

export default useBundlePricing;
